import React from 'react';
import cx from 'classnames';

import styles from './OrgWeights.module.scss';

/**
 * Ancestor gutter lines matching the org structure tree parentage display.
 */
function OrgWeightRowGutters({ pathToNode = [] }) {
  if (!pathToNode.length) {
    return <div className={styles.gutters} />;
  }

  return (
    <div className={styles.gutters}>
      {pathToNode.map((ancestor) => (
        <div
          key={ancestor.pathKey ?? ancestor.depthId}
          className={cx(styles.gutter, {
            [styles['gutter--org-level']]: ancestor.isRoot,
            [styles['gutter--group-level']]: !ancestor.isRoot,
          })}
        />
      ))}
    </div>
  );
}

export default OrgWeightRowGutters;
